/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { Footer } from '@components/systems'
import Markdown from 'markdown-to-jsx'

import { grey } from '@mui/material/colors'

const StorePolicyPage = () => {
	const [markdown, setMarkdown] = React.useState('')

	React.useEffect(() => {
		// @ts-ignore */
		const newLocal = import('./policies/storePolicy_en.md')
		newLocal
			.then(res => {
				fetch(res.default)
					.then(res => res.text())
					.then(res => setMarkdown(res))
					.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
	})

	return (
		<View css={style}>
			<View className="outerView">
				<View className="contentOuterView">
					<View className="contentView">
						<Markdown>{markdown}</Markdown>
					</View>
				</View>
			</View>
			<Footer />
		</View>
	)
}

export default StorePolicyPage

const style = css({
	position: 'relative',
	width: '100%',

	'.outerView': {
		display: 'flex',
		paddingTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey[300],

		'.contentOuterView': {
			width: '100%',
			padding: '2rem',

			'.contentView': {
				textAlign: 'left',
			},
		},
	},
})
